import { render, staticRenderFns } from "./part-c.vue?vue&type=template&id=3988d031&"
import script from "./part-c.vue?vue&type=script&lang=js&"
export * from "./part-c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports